var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.publisher,
        title: _vm.$t("PAUSE_AFFILIATE_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("PAUSE_AFFILIATE_MODAL_CANCEL_ACTION"),
        "confirm-action-text": _vm.$t("PAUSE_AFFILIATE_MODAL_CONFIRM_ACTION"),
        "show-cancel-button": _vm.showActions,
        "show-confirm-button": _vm.showActions
      },
      on: { confirm: _vm.confirmPause, close: _vm.closePauseModal }
    },
    [
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("PAUSE_AFFILIATE_MODAL_TEXT", {
              affiliateName: _vm.publisher.name
            })
          )
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }